import Entity from '../entity'

export default class AuditLog extends Entity<number>{
    endpoint: string;
    method: string;
    browser_info: string;
    ip_address: string;
    status_code: number;
    error_message: string;
    stack_trace: string;
    request_body: string;
    query_string: string;
    user_id: number;
    created_at: string;
}


